import { render, staticRenderFns } from "./StatView.vue?vue&type=template&id=7ec36ca9&scoped=true&"
import script from "./StatView.vue?vue&type=script&lang=js&"
export * from "./StatView.vue?vue&type=script&lang=js&"
import style0 from "./StatView.vue?vue&type=style&index=0&id=7ec36ca9&prod&lang=css&"
import style1 from "@/css/a.css?vue&type=style&index=1&id=7ec36ca9&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec36ca9",
  null
  
)

export default component.exports